import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {
  NTER_PRINT_FOOTER,
  NTER_PRINT_HEADER
} from "projects/soko-console-web-v2/src/app/shared/constants/nter-print-header-footer.constant";
import {displayShortDate} from "@ui-kit/framework/util/static/date-format-utils";
import {environment} from "@env/environment";
import {ConsoleContextService} from "@security/console-context.service";
import {CustomPrintStyles, PrintDocumentInfo, PrintBody} from "src/app/shared/interfaces/print.interface";

@Injectable({
  providedIn: 'root'
})
export class BasePrintService {
  svgLogoString: string = '';

  constructor(protected context: ConsoleContextService,
              protected http: HttpClient) {
    this.loadSvgAsString();
  }

  protected async getPrintPdf(docInfo: PrintDocumentInfo, offeringId: string, urlSuffix: string, headers?: any, customStyles?: CustomPrintStyles,) {
    const headerTemplate = await this.getHeaderTemplate(docInfo.title, docInfo.subtitle, docInfo.docId);
    const footerTemplate = await this.getFooterTemplate(offeringId);

    const theme = {
      "--primary-color": this.color('--primary-color'),
      "--secondary-color": this.color('--secondary-color'),
    }

    const body: PrintBody = {
      headerTemplate,
      footerTemplate,
      docInfo,
      customStyles: {
        ...customStyles,
        theme
      }
    }

    return this.http.post(environment.apiPrintPdf + urlSuffix, body,
      {
        headers: {...headers},
        responseType: 'blob',
      });
  }

  private async getHeaderTemplate(title: string, subtitle: string, docId: string): Promise<string> {
    let header = NTER_PRINT_HEADER;

    try {
      const client = await this.context.getCurrentWebClient();
      if (client) {
        header = header.replace('{{landlordLogo}}', client.companyLogo || '');
        header = header.replace('{{docTitle}}', title);
        header = header.replace('{{docSubtitle}}', subtitle);
        header = header.replace('{{docId}}', docId);
        return header;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Error getting client:', error);
      return '';
    }
  }

  private async getFooterTemplate(offeringId: string): Promise<string> {
    let footer = NTER_PRINT_FOOTER;
    const currentUser = this.context.currentUser!;

    try {
      const client = await this.context.getCurrentWebClient();
      console.log(offeringId, this.context.getCurrentLocationOffering(offeringId));
      if (client) {
        footer = footer.replace('{{landlordName}}', client!.companyName);
        footer = footer.replace('{{locationName}}', this.context.getCurrentLocation()!.locationName);
        footer = footer.replace('{{offeringName}}', this.context.getCurrentLocationOffering(offeringId)!.offeringName);
        footer = footer.replace('{{generatedOn}}', displayShortDate(new Date())!);
        footer = footer.replace('{{generatedBy}}', `${currentUser.firstname} ${currentUser.lastname}`);
        footer = footer.replace('{{generatedYear}}', new Date().getFullYear().toString());
        footer = footer.replace('{{svgLogo}}', this.svgLogoString);
        return footer;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Error getting client:', error);
      return '';
    }
  }

  private loadSvgAsString() {
    this.http.get('/assets/icons/default-nter-logo.svg', {responseType: 'text'})
      .subscribe({
        next: (svgContent) => {
          this.svgLogoString = this.setSvgDimensions(svgContent, '28px', '28px');
          console.log('SVG loaded:');
        },
        error: (error) => {
          console.error('Error loading SVG:', error);
        }
      });
  }

  private setSvgDimensions(svgContent: string, width: string, height: string): string {
    // Remove existing width and height attributes if they exist
    let modifiedSvg = svgContent.replace(/width="[^"]*"/g, '');
    modifiedSvg = modifiedSvg.replace(/height="[^"]*"/g, '');

    // Add new width and height attributes to the opening <svg> tag
    modifiedSvg = modifiedSvg.replace('<svg', `<svg width="${width}" height="${height}"`);

    return modifiedSvg;
  }

  private color(color: string): string {
    const rootStyles = window.getComputedStyle(document.documentElement);
    return rootStyles.getPropertyValue(color).trim();
  }
}
